import { useEffect, useState } from 'react';
import { propFirmData } from '../data/propFirmDataHomepage';
import HeroCarouselCard from './HeroCarouselCard';

export function HeroCarousel() {
  const firmsWithDiscounts = Object.values(propFirmData).filter(
    (firm) =>
      firm.evaluation?.discount?.code &&
      (!firm.evaluation?.discount?.validUntil || new Date(firm.evaluation.discount.validUntil) > new Date())
  );

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % firmsWithDiscounts.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [firmsWithDiscounts.length]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + firmsWithDiscounts.length) % firmsWithDiscounts.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % firmsWithDiscounts.length);
  };

  const currentFirm = firmsWithDiscounts[currentIndex];

  return (
    <div className="flex justify-center items-center w-full">
      <HeroCarouselCard firm={currentFirm} onPrev={handlePrev} onNext={handleNext} />
    </div>
  );
}

export default HeroCarousel;
